import { startAdaHandoffCable, stopAdaHandoffCable } from "@shared/helpers/adaHandoff/adaHandoff";
import { setupIntercom, setupAdaToIntercomHandoff } from "@shared/helpers/intercom/intercom";

// Legacy Rails templates call these globals from inline ERB scripts.
window.startAdaHandoffCable = startAdaHandoffCable;
window.stopAdaHandoffCable = stopAdaHandoffCable;
window.setupIntercom = setupIntercom;
window.setupAdaToIntercomHandoff = setupAdaToIntercomHandoff;
